var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNewguest = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.69476 8.69231C10.8189 8.69231 12.5409 6.97032 12.5409 4.84615C12.5409 2.72198 10.8189 1 8.69476 1C6.5706 1 4.84863 2.72198 4.84863 4.84615C4.84863 6.97032 6.5706 8.69231 8.69476 8.69231Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0024 19.4615H1.77173V18.6275C1.78398 17.4549 2.09323 16.3044 2.6706 15.2838C3.24798 14.2631 4.07463 13.4053 5.07335 12.7907C6.07208 12.1761 7.21029 11.8247 8.38164 11.7692C9.55302 11.7138 10.7193 11.9561 11.7716 12.4736",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.156 11.7693V21.0001",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.541 16.3845H21.7717",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNewguest);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/newguest.40e37ab4cb8030c5df7a57ce7c1d43f8.svg";